import MetadataView from './MetadataView';
export default MetadataView;